import * as Yup from "yup";

import { FEATURE_STATUS, featureStatusLabels } from "@/constant/GeneralOptions/feature-status";

const getCountrySchema = () =>
  Yup.object().shape({
    region: Yup.string()
      .label("Region")
      .required()
      .max(255),
    country_id: Yup.number()
      .label("Country")
      .required(),
    customs_region: Yup.string()
      .label("Customs Region")
      .nullable()
      .max(255),
    enable_professional_user: Yup
      .number()
      .label("Enable Professional User")
      .required()
      .oneOf(
        Object.values(FEATURE_STATUS),
        `Enable Professional User must be one of the following values: ${Object.values(featureStatusLabels).join(", ")}`
      ),
    enable_personal_user: Yup
      .number()
      .label("Enable Personal User")
      .required()
      .oneOf(
        Object.values(FEATURE_STATUS),
        `Enable Personal User must be one of the following values: ${Object.values(featureStatusLabels).join(", ")}`
      ),
    vat_merchandise: Yup.number()
      .label("VAT Merchandise")
      .required()
      .min(0)
      .max(100)
      .test(
        "decimal-places",
        "Rate must have at most 1 decimal place",
        (value) => /^\d+(\.\d{1})?$/.test(value?.toString() || "")
      ),
    vat_e_service: Yup.number()
      .label("VAT E-Service")
      .required()
      .min(0)
      .max(100)
      .test(
        "decimal-places",
        "Rate must have at most 1 decimal place",
        (value) => /^\d+(\.\d{1})?$/.test(value?.toString() || "")
      ),
    ship_to_location_code: Yup
      .string()
      .label("Default Ship-To Location")
      .nullable(),
    language_code: Yup
      .string()
      .label("Default Language")
      .nullable(),
    currency_code: Yup
      .string()
      .label("Default Currency")
      .nullable(),
    sport_id: Yup
      .number()
      .label("Default Sport")
      .nullable(),
  });

export default getCountrySchema;
